<template>
    <div class="archives-list-filters">
        <div class="filters">
            <MiniFilterPreview
                type="period"
                v-model="clone.period"
                v-if="!!clone.period"
                :startDate="clone.startDate"
                :endDate="clone.endDate"
                :on-removed="
                    () => {
                        clone.period = null;
                        clone.startDate = null;
                        clone.endDate = null;
                    }
                "
                @dateRange="setDateRange($event)"
                :label="getFilterLabel('period')"
                :default-open="lastAddedFilter === 'period'"
                :on-finished="() => (lastAddedFilter = null)"
                :key="clone.period"
                :autoRemoveWhenCancel="lastAddedFilter === 'period'"
            />
            <MiniFilterPreview
                type="integration"
                v-model="clone.integration"
                v-if="!!clone.integration"
                :on-removed="() => (clone.integration = null)"
                :label="getFilterLabel('integration')"
                :default-open="lastAddedFilter === 'integration'"
                :on-finished="() => (lastAddedFilter = null)"
                :key="clone.integration"
                :autoRemoveWhenCancel="lastAddedFilter === 'integration'"
            />
            <MiniFilterPreview
                type="visitorId"
                v-model="clone.visitorId"
                v-if="!!clone.visitorId"
                :on-removed="() => (clone.visitorId = null)"
                :label="getFilterLabel('visitorId')"
                :default-open="lastAddedFilter === 'visitorId'"
                :on-finished="() => (lastAddedFilter = null)"
                :key="clone.visitorId"
                :autoRemoveWhenCancel="lastAddedFilter === 'visitorId'"
            />
            <MiniFilterPreview
                type="conversationId"
                v-model="clone.conversationId"
                v-if="Object.keys(clone).includes('conversationId') && !!clone.conversationId"
                :on-removed="() => (clone.conversationId = null)"
                :label="getFilterLabel('conversationId')"
                :default-open="lastAddedFilter === 'conversationId'"
                :on-finished="() => (lastAddedFilter = null)"
                :key="clone.conversationId"
                :autoRemoveWhenCancel="lastAddedFilter === 'conversationId'"
            />
            <MiniFilterPreview
                type="storyId"
                v-model="clone.storyId"
                v-if="Object.keys(clone).includes('storyId') && !!clone.storyId"
                :on-removed="() => (clone.storyId = null)"
                :label="getFilterLabel('storyId')"
                :default-open="lastAddedFilter === 'storyId'"
                :on-finished="() => (lastAddedFilter = null)"
                :key="clone.storyId"
                :autoRemoveWhenCancel="lastAddedFilter === 'storyId'"
            />
            <MiniFilterPreview
                type="userIds"
                v-model="clone.userIds"
                v-if="Object.keys(clone).includes('userIds') && !!clone.userIds"
                :on-removed="() => (clone.userIds = null)"
                :label="getFilterLabel('userIds')"
                :default-open="lastAddedFilter === 'userIds'"
                :on-finished="() => (lastAddedFilter = null)"
                :users="users"
                :key="clone.userIds"
                :autoRemoveWhenCancel="lastAddedFilter === 'userIds'"
                v-tippy="{ content: getFilterLabel('userIds') }"
            />

            <a-popover
                :visible="filterMenuVisible"
                :overlayClassName="'filterMenu no-padding'"
                placement="bottom"
                @visibleChange="(isVisible) => (filterMenuVisible = isVisible)"
                trigger="click"
            >
                <div slot="content">
                    <div class="custom-list-wrapper filter-list-bg">
                        <div class="custom-list">
                            <div
                                class="custom-list-item"
                                @click="addFilter('period')"
                                v-if="Object.keys(clone).includes('period')"
                            >
                                <span class="material-icons"> date_range </span>
                                {{ $t("chatbotv2.date") }}
                            </div>
                            <div
                                class="custom-list-item"
                                @click="addFilter('userIds')"
                                v-if="Object.keys(clone).includes('userIds')"
                            >
                                <span class="material-icons"> badge</span>
                                Kullanıcı Filtre
                            </div>
                            <div
                                class="custom-list-item"
                                @click="addFilter('visitorId')"
                                v-if="Object.keys(clone).includes('visitorId') && !isGraphShowing"
                            >
                                <span class="material-icons">fingerprint</span>
                                {{ $t("chatbotv2.userId") }}
                            </div>
                            <div
                                class="custom-list-item"
                                @click="addFilter('conversationId')"
                                v-if="Object.keys(clone).includes('conversationId') && !isGraphShowing"
                            >
                                <span class="material-icons">fingerprint</span>
                                {{ $t("chatbotv2.conversationId") }}
                            </div>
                            <div
                                class="custom-list-item"
                                @click="addFilter('integration')"
                                v-if="Object.keys(clone).includes('integration')"
                            >
                                <span class="material-icons">public</span>
                                {{ $t("chatbotv2.integration") }}
                            </div>
                            <div
                                class="custom-list-item"
                                @click="addFilter('storyId')"
                                v-if="Object.keys(clone).includes('storyId')"
                            >
                                <span class="material-icons">schema</span>
                                {{ $t("chatbotv2.story") }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add-button">
                    <span class="material-icons"> add </span>
                    <div class="add-button-text">{{ $t("chatbotv2.addFilter") }}</div>
                </div>
            </a-popover>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../utils/log2";
import _ from "lodash";
import { mapState } from "vuex";
import MiniFilterPreview from "./MiniFilterPreview";
import moment from "moment";

const log = log2("FilterTool");
export default {
    name: "FilterTool",
    components: {
        MiniFilterPreview,
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        users: {
            type: Array,
            default: () => [],
        },
        getAttributes: {
            type: Function,
            default: () => {},
        },
        getAllVisitorId: {
            type: Function,
            default: () => {},
        },
        getConversationById: {
            type: Function,
            default: () => {},
        },
        isGraphShowing: {
            type: Boolean,
            default: false,
        },
        keepStateOnQueryParams: {
            type: Boolean,
            default: () => false,
        },
        userId: {
            type: String,
            default: () => "",
        },
    },
    data() {
        return {
            filterMenuVisible: false,
            clone: _.cloneDeep(this.value),
            lastAddedFilter: null,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
        getFilterTranslate(filter) {
            return this.$t(`time.${filter}`);
        },
    },
    methods: {
        setDateRange($e) {
            this.clone.startDate = $e.startDate && moment($e.startDate.split(" ")[0]).endOf("day").toISOString();
            this.clone.endDate = $e.endDate && moment($e.endDate.split(" ")[0]).endOf("day").toISOString();
        },
        addFilter(key) {
            log("key", key);
            if (key === "period") {
                this.clone[key] = "today";
            } else if (key === "integration") {
                this.clone[key] = "web";
            } else if (key === "visitorId") {
                this.clone[key] = !!this.getAllVisitorId().length ? this.getAllVisitorId()[0] : "";
            } else if (key === "conversationId") {
                this.clone[key] = !!this.getConversationById().length ? this.getConversationById()[0] : "";
            } else if (key === "storyId") {
                this.clone[key] = !!this.stories ? this.stories.map((story) => story._id)[0] : "";
            } else if (key === "userIds") {
                this.clone[key] = this.users[0]._id;
            }
            this.lastAddedFilter = key;

            this.filterMenuVisible = false;
        },
        getFilterLabel(type) {
            if (!this.clone) {
                return "";
            }
            if (type === "storyId") {
                const story = this.stories.find((story) => story._id === this.clone.storyId);
                return `Story is ${_.get(story, "title")}`;
            } else if (type === "period") {
                log("getFilterLabel", this.clone);
                const isCustom = this.clone.period === "custom";
                const startDate = isCustom ? moment(this.clone.startDate).format("LL") : "";
                const endDate = isCustom ? moment(this.clone.endDate).format("LL") : "";
                const periods = [
                    { value: "today", label: this.$t("time.today") },
                    { value: "yesterday", label: this.$t("time.yesterday") },
                    { value: "last7", label: this.$t("time.last7") },
                    { value: "last30", label: this.$t("time.last30Day") },
                    { value: "this-month", label: this.$t("time.currentMonth") },
                    { value: "last-month", label: this.$t("time.lastMonth") },
                    { value: "last-3-month", label: this.$t("time.last3Months") },
                    { value: "this-year", label: this.$t("time.thisYear") },
                    { value: "last-year", label: this.$t("time.lastYear") },
                    { value: "custom", label: isCustom ? `${startDate} - ${endDate}` : this.$t("time.custom") },
                ];
                return periods.find((period) => period.value === this.clone.period).label;
            } else if (type === "visitorId") {
                log(`User = ${this.clone.visitorId}`);
                return `User = ${this.clone.visitorId}`;
            } else if (type === "conversationId") {
                log(`Conversation = ${this.clone.conversationId}`);
                return `Conversation = ${this.clone.conversationId}`;
            } else if (type === "integration") {
                return `Integration is ${this.clone.integration.toUpperCase()}`;
            } else if (type === "userIds") {
                const usersId = this.users
                    .filter((user) => this.clone.userIds.includes(user._id))
                    .map((user) => user.name);
                return `${(usersId || []).join(", ")}`;
            } else {
                return "";
            }
        },
        updateQueryParams(key, value) {
            if (value === "" || value == null) {
                let query = Object.assign({}, this.$route.query);
                delete query[key];
                this.$router.replace({ query });
            } else {
                let { query } = this.$route;
                this.$router.replace({
                    query: { ...query, [key]: encodeURI(value) },
                });
            }
        },
        keepState(filters) {
            if (this.keepStateOnQueryParams) {
                this.updateQueryParams("period", filters["period"]);
                this.updateQueryParams("integration", filters["integration"]);
                this.updateQueryParams("storyId", filters["storyId"]);
                this.updateQueryParams("visitorId", filters["visitorId"]);
                this.updateQueryParams("conversationId", filters["conversationId"]);
                this.updateQueryParams("startDate", filters["startDate"]);
                this.updateQueryParams("endDate", filters["endDate"]);
                this.updateQueryParams("userIds", (filters["userIds"] || []).join(","));
            }
        },
    },
    mounted() {
        log("this.value...", this.value);
    },
    watch: {
        clone: {
            handler(newValue) {
                this.$emit("input", newValue);
                this.keepState(newValue);
            },
            deep: true,
        },
        userId: {
            handler(newValue) {
                this.$emit("input", newValue);
                this.keepState(newValue);
            },
            deep: true,
        },
        lastAddedFilter(newVal) {
            if (!newVal) {
                if (!_.isEqual(this.clone, this.value)) {
                    this.$emit("input", this.clone);
                }
            }
        },
        value: {
            handler(newValue) {
                if (_.isEqual(newValue, this.clone)) {
                    return;
                }
                this.clone = _.cloneDeep(newValue);
                this.lastAddedFilter = null;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.archives-list-filters {
    border-bottom: 1px solid #dbe1e8;
    overflow: hidden;
    padding: 20px 20px 10px;

    .filters {
        display: flex;
        flex-wrap: wrap;
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;
        gap: 10px;
    }

    .add-button {
        margin-left: 10px;
        display: flex;
        min-width: 80px;
        align-items: center;
        width: fit-content !important;
        height: 32px;
        margin: 0 10px 10px 0;
        cursor: pointer;
        transition: all 0.3s;
        background: #fff;
        border: 1px solid #dbe1e8;
        color: #22272d;
        line-height: 28px;
        border-radius: 4px;
        font-family: Source Sans Pro, sans-serif;
        font-weight: 600;
        padding: 0 10px;
        text-align: center;
        user-select: none;

        .material-icons {
            color: #006cff;
        }

        &:hover {
            opacity: 0.8;
        }
    }
}

.custom-list-wrapper {
    display: flex;
    flex-direction: column;
    max-height: 99vh;
    max-width: 300px;
    overflow: hidden;

    .custom-list {
        overflow-x: hidden;
        overflow-y: auto;

        .custom-list-item {
            align-items: center;
            cursor: pointer;
            display: flex;
            height: 35px;
            padding: 0 16px;
            transition: all 0.3s;
            width: 100%;
            background: #f5f7fa;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #22272d;
            font-weight: 400;
            font-size: 15px;
            line-height: 19px;

            .material-icons {
                color: #008aff;
                font-size: 14px;
                margin-right: 10px;
                transition: all 0.3s;
            }

            &:hover {
                background: #008aff;
                color: #fff;
                opacity: 0.8;

                .material-icons {
                    color: #fff;
                }
            }
        }

        .custom-list-item:first-child {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }
    }
}

.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
        width: auto;
    }
}
</style>
